import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import api from '../../services/api_despesas';
import stylesIndex from "./index-styles.module.css";
import { MdDesktopAccessDisabled } from 'react-icons/md'

export default function IntegracaoOs() {
    const [perfis, setPerfis] = useState([]);
    const [modulos, setModulos] = useState([]);
    const [loading, setLoading] = useState(true);

    let history = useHistory();

    useEffect(() => {
        api.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data.usuario_perfil && response.data.usuario_modulo) {
                setPerfis(response.data.usuario_perfil);
                setModulos(response.data.usuario_modulo);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(() => {
            setLoading(false);
        });
    }, []);

    function renderManutecaoIntegracaoOs() {
        // if(perfis.find(({ perfil_id }) => perfil_id === 5)) {
        //     return (
        //         <>
        //             <hr />
        //             <h4 className={stylesIndex.optionstitle}>MANUTENÇÕES</h4>
        //             <div className={stylesIndex.optionsconteiner}>
        //                 <input type="button" className={stylesIndex.optionsbutton} value="LISTA DE FORMULÁRIOS" onClick={() => history.push('/listaformularios', {hasAccess: true})} />
        //             </div>
        //         </>
        //     )
        // }
    }

    function handleFormulario(tipo) {
        history.push('/formularioos', {hasAccess: true, tipo_os: tipo});
    }

    function renderFormularioOs() {
        return (
            <>
                <h4 className={stylesIndex.optionstitle}>FORMULÁRIOS</h4>
                <div className={stylesIndex.optionsconteiner}>
                    <input type="button" className={stylesIndex.optionsbutton} value="LISTA DE FORMULÁRIOS" onClick={() => history.push('/listaformularios', {hasAccess: true})} />
                </div>
                <div className={stylesIndex.optionsconteiner}>
                    <input type="button" className={stylesIndex.optionsbutton} value="ORÇAMENTO DE SERVIÇOS" onClick={() => handleFormulario(0)} />
                    <input type="button" className={stylesIndex.optionsbutton} value="ORÇAMENTO DE RECAPAGEM" /* onClick={() => handleFormulario(1)} */ disabled title='(Em Desenvolvimento)'/>
                    {/* <input type="button" className={stylesIndex.optionsbutton} value="REMESSA" onClick={() => handleFormulario(2)} />
                    <input type="button" className={stylesIndex.optionsbutton} value="DEVOLUÇÃO" onClick={() => handleFormulario(3)} />
                    <input type="button" className={stylesIndex.optionsbutton} value="GARANTIA" onClick={() => handleFormulario(4)} /> */}
                </div>
            </>
        )
    }

    function renderOptions() {
        if(!loading) {
            if(modulos.find(({ modulos_id }) => modulos_id === 16)) {
                return (
                    <>
                        {renderFormularioOs()}
                        {renderManutecaoIntegracaoOs()}
                    </>
                )
            } else {
                return (
                    <>
                        <MdDesktopAccessDisabled style={{width: '100%', maxWidth: '200px', height: 'auto'}}/>
                        <div className={stylesIndex.optionstitle}>
                            VOCÊ NÃO TEM ACESSO A ESSE MÓDULO!
                        </div>
                    </>
                )
            }
        }
    }

    return (
        <div className="container-lg">
            <Header title="INTEGRAÇÃO ORDEM DE SERVIÇO" />
            {renderOptions()}
        </div>
    )
}